import { Pipe, PipeTransform } from '@angular/core';
import { InstallationBobstContactPluginService } from './bobst-contact.service';

@Pipe({
    name: 'ownerType',
    standalone: false
})
export class OwnerTypePipe implements PipeTransform {
  constructor(private service: InstallationBobstContactPluginService) {}

  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.service.getOwnerTypes());
  }
}
